<script setup>

import { Button } from '../../ui/button/index.js'
import { defineProps, defineEmits } from 'vue'
import { Trash } from 'lucide-vue-next'

const props = defineProps({
  // You can define props here if needed
  deleteByColumn: {
    type: String,
    required: false,
    default: 'id'
  },
  size: {
    type: String,
    required: false,
    default: 'default'
  },
  deleteByValue: {
    type: [String, Number],
    required: true
  },
  useStore: {
    type: Object,
    required: true
  },
  iconOnly: {
    type: Boolean,
    required: false,
    default: false
  },
  noIcon: {
    type: Boolean,
    required: false,
    default: false
  }
})

const emit = defineEmits(['deleted','deleting'])

const handleDelete = async () => {
  // Emit deleting event
  if(!confirm('Are you sure you want to delete this item? This action cannot be undone.')) {
    return;
  }
  emit('deleting', { [props.deleteByColumn]: props.deleteByValue });
  await props.useStore.itemDelete(props.deleteByValue)
  // Emit deleted event
  emit('deleted', { [props.deleteByColumn]: props.deleteByValue });
};


</script>

<template>
  <Button :size="size" :loading="useStore.isLoadingItems.indexOf(deleteByValue) > -1" variant="destructive" @click="handleDelete">
    <Trash v-if="!noIcon" /> <slot> <span v-if="!iconOnly">{{ $t('actions.delete') }}</span> </slot>
  </Button>
</template>

<style scoped>

</style>
